import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, Subject } from "rxjs";
import { catchError, shareReplay, switchMap, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { LogCategory, LoggerService, LogService, LogType } from '../core/services/logger.service';


@Injectable({
    providedIn: 'root'
})
export class TableauService {

    public tableauMessage: string = "";

    constructor(
        private http: HttpClient,
        private logger: LoggerService
    ) {
        this.log("constructor", null, LogCategory.Constructor);
    }

    private log(method: string = null, message = null, category: LogCategory = LogCategory.Default): void {
        method = (method) ? '.' + method + '()' : '';
        message = (message) ? message.toString() : '';
        this.logger.try(this.constructor.name + method + ': ' + message, LogType.Service, LogService.MySupportRequests, category);
    }

    private _listRequests$: BehaviorSubject<boolean> = new BehaviorSubject(false);

    public newTableauRequest$: Subject<any> = new Subject();
    public addTableauRequest$: Observable<any> = this.newTableauRequest$
        .pipe(            
            switchMap((request) => {                
                return this.http.post<any>(environment.apiUrl + '/tableau/self/addRequest', request)
                    .pipe(
                        tap(() => {                            
                            this.tableauMessage = "Tableau request has been submitted!";
                            this._tableauRequests$ = null;
                            this._listRequests$.next(true);
                        }),
                        catchError(error => { return of() })                        
                    )                
            }),                                
            shareReplay(1)            
        )

    // Using a local cache, so that we don't want keep fetching requests every time the modal opens (even though its only a small amount of data)
    // The fetch should happen when the modal is first opened and then everytime a new request is added
    private _tableauRequests$: Observable<any>
  
    public myTableauRequests$: Observable<any> = this._listRequests$.pipe(        
        switchMap((value) => {           
            if (!this._tableauRequests$) {
                this._tableauRequests$ = this.http.get<any>(environment.apiUrl + '/tableau/self/requests').pipe(
                    tap(() => { this.log('_myTableauRequests$', 'Fetched requests for current user', LogCategory.SubscriptionData) }),
                    shareReplay(1))                    
           }
            return this._tableauRequests$;
        })

    );

    private _tableauDashboards$: Observable<any>
    public get tableauDashboards$(): Observable<any> {
        if (!this._tableauDashboards$) {
            this._tableauDashboards$ = this.http.get<any>(environment.apiUrl + '/tableau/self/dashboards').pipe(
                tap(() => this.log('_tableauDashboards$', 'Fetched all tableau dashboard types', LogCategory.SubscriptionData)),
                shareReplay(1)
            )
        }
        return this._tableauDashboards$;
    }

    public refresh() {
        this._tableauRequests$ = null;
        this._tableauDashboards$ = null;
    }

}
